import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Library = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.643 1a1.048 1.048 0 0 0-1.874.936L40.51 43.42a1.048 1.048 0 0 0 1.875-.937L21.643.999ZM2.548.42c.578 0 1.047.47 1.047 1.048v41.904a1.048 1.048 0 1 1-2.095 0V1.468C1.5.889 1.969.42 2.548.42ZM12.325.42c.579 0 1.048.47 1.048 1.048v41.904a1.048 1.048 0 0 1-2.095 0V1.468c0-.579.469-1.048 1.047-1.048Z"
  }));
});
Library.displayName = 'Library';
Library.defaultProps = {
  'aria-label': 'Library'
};
export default Library;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Library.js
// module id = 3825
// module chunks = 11